import Api from "./Api";

const abortKey = "MitgliederApi";
const endpoint = "/mitglieder";
export default {
    abort() {
        Api.abort(abortKey);
    },
    get(params) {
        var usedParams = {};

        Api.handleDefaultParams(params, usedParams);

        usedParams.limit = params.limit;
        usedParams.page = params.page;
        usedParams.order = params.order;
        usedParams.sort = params.sort;

        return Api.fetchData(endpoint, usedParams, true, false, abortKey);
    },
    getOPRelevants(params) {
        var usedParams = {};

        Api.handleDefaultParams(params, usedParams);

        usedParams.limit = params.limit;
        usedParams.page = params.page;
        usedParams.order = params.order;
        usedParams.sort = params.sort;

        return Api.fetchData(endpoint + "/op-relevant", usedParams, true, false, abortKey);
    },
    getSingle(id, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);

        return Api.fetchData(endpoint + "/" + id, usedParams);
    },
    getContact(id) {
        return Api.fetchData(endpoint + "/contact/" + id);
    },
    getLeitungsteamForMitglied(id) {
        return Api.fetchData(endpoint + "/leitungsteam/" + id);
    },
    getLeitungsteamGroups() {
        return Api.fetchData(endpoint + "/leitungsteam/groups");
    },
    getLeitungsteamRoles() {
        return Api.fetchData(endpoint + "/leitungsteam/roles");
    },
    getMitgliederStatus(id) {
        return Api.fetchData(endpoint + "/" + id + "/status");
    },
    getMattermost(id) {
        return Api.fetchData(endpoint + "/mattermost/" + id, null, false, true);
    },
    getEvaluation() {
        return Api.fetchData(endpoint + "/evaluation");
    },
    exportMitgliederliste(params, format = "P") {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        usedParams.format = format;
        return Api.fetchData(endpoint + "/print", usedParams);
    },
    exportExcel(params, format = "csv") {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        usedParams.format = format;
        return Api.fetchData(endpoint + "/export", usedParams);
    },
    exportMitgliederausweise(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint + "/ausweis", usedParams);
    },
    getHonorarBuchungen(params, year) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint + "/honorarbescheinigungen", usedParams);
    },
    exportAnniversary(type) {
        var usedParams = {};
        usedParams.type = type;
        return Api.fetchData(endpoint + "/anniversary", usedParams);
    },
    exportRegistrationForm() {
        return Api.fetchData(endpoint + "/registration_form");
    },
    getStatus() {
        return Api.fetchData(endpoint + "/status");
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    putContact(id, data) {
        return Api.putData(endpoint + "/contact/" + id, data);
    },
    putMattermost(id, data) {
        return Api.putData(endpoint + "/mattermost/" + id, data);
    },
    putLeitungsteam(id, data) {
        return Api.putData(endpoint + "/leitungsteam/" + id, data);
    },
    post(data) {
        return Api.postData(endpoint, data);
    }
};
